module.exports = __webpack_public_path__ + "img/customer-icon.0220b715.png";